import React from 'react';
import Dropdown from '../../../Global/Dropdown';
import Toggle from '../../../Global/Toggle';
import TeacherSelections from '../../../Reports/containers/TeacherSelections';
import { getUserData, setUserData } from '../../../../services/API';
import { updateAmiraLicenseConfig, updateSORConfig } from '../../../../services/amiraLicenseService';
import { TEACHER_LAYOUT } from '../../constants';
import { GetBrandedTutorName, GetBrandedAppName, GetBrandedStandardPracticeIcon, GetBrandedSkillScaffoldIcon } from '../../../../services/BrandingService';
import SelectCurriculum from './ScienceOfReadingConfig/SelectCurriculum';
import SelectCustomARMLevelMapping from './ScienceOfReadingConfig/SelectARMCustomLevelMapping';

const interventionFrequencyOpts = [
  {
    id: 'optionHigh',
    value: 'HIGH',
    label: `High - ${GetBrandedTutorName()} will intervene frequently during practice`,
  },
  {
    id: 'optionStandard',
    value: 'STANDARD',
    label: `Standard - ${GetBrandedTutorName()} will intervene at a normal rate during practice`,
  },
  {
    id: 'optionLow',
    value: 'LOW',
    label: `Low - ${GetBrandedTutorName()} will intervene infrequently during practice`,
  }
];

const standardReporting = [
  {
    id: 'commonCore',
    value: 'COMMON_CORE',
    label: 'Common Core',
    additionalInfo: `${GetBrandedAppName()} will show Common Core standards associated with skills in reports.`,
  },
  {
    id: 'az',
    value: 'AZ',
    label: 'Arizona English Language Arts',
    additionalInfo: `${GetBrandedAppName()} will show Arizona standards associated with skills in reports.`,
  },
  {
    id: 'ak',
    value: 'AK',
    label: 'Alaska English Language Arts Standards',
    additionalInfo: `${GetBrandedAppName()} will show Alaska standards associated with skills in reports.`,
  },
  {
    id: 'fl',
    value: 'FL',
    label: 'Florida BEST (Benchmarks for Excellent Student Thinking)',
    additionalInfo: `${GetBrandedAppName()} will show Florida standards associated with skills in reports.`,
  },
  {
    id: 'ga',
    value: 'GA',
    label: 'Georgia Standards of Excellence',
    additionalInfo: `${GetBrandedAppName()} will show Georgia standards associated with skills in reports.`,
  },
  {
    id: 'ia',
    value: 'IA',
    label: 'Iowa Academic Standards',
    additionalInfo: `${GetBrandedAppName()} will show Iowa standards associated with skills in reports.`,
  },
  {
    id: 'id',
    value: 'ID',
    label: 'Idaho Content Standards',
    additionalInfo: `${GetBrandedAppName()} will show Idaho standards associated with skills in reports.`,
  },
  {
    id: 'in',
    value: 'IN',
    label: 'Indiana Academic Standards',
    additionalInfo: `${GetBrandedAppName()} will show Indiana standards associated with skills in reports.`,
  },
  {
    id: 'ky',
    value: 'KY',
    label: 'Kentucky Academic Standards for Reading & Writing',
    additionalInfo: `${GetBrandedAppName()} will show Kentucky standards associated with skills in reports.`,
  },
  {
    id: 'la',
    value: 'LA',
    label: 'Louisiana Student Standards',
    additionalInfo: `${GetBrandedAppName()} will show Louisiana standards associated with skills in reports.`,
  },
  {
    id: 'nd',
    value: 'ND',
    label: 'North Dakota English Language Arts Standards',
    additionalInfo: `${GetBrandedAppName()} will show North Dakota standards associated with skills in reports.`,
  },
  {
    id: 'ne',
    value: 'NE',
    label: 'Nebraska’s College and Career Ready Standards for English Language Arts',
    additionalInfo: `${GetBrandedAppName()} will show Nebraska standards associated with skills in reports.`,
  },
  {
    id: 'ny',
    value: 'NY',
    label: 'New York State Next Generation English Language Arts Standards',
    additionalInfo: `${GetBrandedAppName()} will show New York standards associated with skills in reports.`,
  },
  {
    id: 'nv',
    value: 'NV',
    label: 'Nevada Academic Content Standards for English Language Arts',
    additionalInfo: `${GetBrandedAppName()} will show Nevada standards associated with skills in reports.`,
  },
  {
    id: 'oh',
    value: 'OH',
    label: 'Ohio Learning Standards for ELA',
    additionalInfo: `${GetBrandedAppName()} will show Ohio standards associated with skills in reports.`,
  },
  {
    id: 'ok',
    value: 'OK',
    label: 'Oklahoma Academic Standards for English Language Arts',
    additionalInfo: `${GetBrandedAppName()} will show Oklahoma standards associated with skills in reports.`,
  },
  {
    id: 'or',
    value: 'OR',
    label: 'Oregon English Language Arts and Literacy Standards',
    additionalInfo: `${GetBrandedAppName()} will show Oregon standards associated with skills in reports.`,
  },
  {
    id: 'sc',
    value: 'SC',
    label: 'South Carolina College and Career Readiness',
    additionalInfo: `${GetBrandedAppName()} will show South Carolina standards associated with skills in reports.`,
  },
  {
    id: 'teks',
    value: 'TEKS',
    label: 'TEKS',
    additionalInfo: `${GetBrandedAppName()} will show TEKS standards associated with skills in reports.`,
  },
  {
    id: 'tn',
    value: 'TN',
    label: 'Tennessee English Language Arts Standards',
    additionalInfo: `${GetBrandedAppName()} will show Tennessee standards associated with skills in reports.`,
  },
  {
    id: 'ut',
    value: 'UT',
    label: 'Utah Core Standards for English Language Arts',
    additionalInfo: `${GetBrandedAppName()} will show Utah standards associated with skills in reports.`,
  },
  {
    id: 'va',
    value: 'VA',
    label: 'Virginia Essentialized Standards of Learning',
    additionalInfo: `${GetBrandedAppName()} will show Virginia standards associated with skills in reports.`,
  },
  {
    id: 'wa',
    value: 'WA',
    label: 'Washington Learning Standards for ELA',
    additionalInfo: `${GetBrandedAppName()} will show Washington standards associated with skills in reports.`,
  }
];

const ConfigCard = ({ title, description, children }) => {
  return (
    <div className='config-card'>
      <div className='config-card-title'>{title}</div>
      {description && <div className='config-card-description'>{description}</div>}
      <div className='config-card-content'>{children}</div>
    </div>
  )
}

class ScienceOfReadingConfig extends React.Component {
  constructor(props) {
    super(props);

    let {sorConfig,schools,districtId, curriculum} = getUserData();
    let standard = standardReporting.find((s)=>s.value === sorConfig.selectedStandard) || standardReporting[0];
    let intervention = interventionFrequencyOpts.find((i)=>i.value === sorConfig.interventionFrequency) || interventionFrequencyOpts[1];

    this.state = {
      imagesInStories: {
        earlyReader: sorConfig.enableERPictures,
        standardAmiraPractice: sorConfig.enablePracticePictures,
      },
      interventionFrequencySelection: intervention,
      standardUsedInReporting: standard,
      districtId,
      schools,
      curriculum,
      ...sorConfig
    };

    this.handleSave = this.handleSave.bind(this);
  }

  handleSave() {
    const {customARMLevelMapping, curriculum, enableGiveWord, enableFandP, 
      enableDRA, enableLexile, districtId, schools, standardUsedInReporting, 
      interventionFrequencySelection, enableExtendedColumns } = this.state;

    const sorConfigInputs = {
      enableGiveWord,
      enableFandP,
      enableDRA,
      enableLexile,
      enableExtendedColumns,
      enableERPictures: this.state.imagesInStories.earlyReader,
      enablePracticePictures: this.state.imagesInStories.standardAmiraPractice,
      selectedStandard: standardUsedInReporting.value,
      interventionFrequency: interventionFrequencySelection.value,
      customARMLevelMapping,
    }
    const amiraLicenseInputs = {
      curriculum,
    }

    setUserData('sorConfig',sorConfigInputs);
    setUserData('curriculum',curriculum);
    updateSORConfig(districtId, schools, sorConfigInputs, amiraLicenseInputs);

    this.props.history.push('/admin');
  }

  render() {
    const selectionProps = {
      pageTitle: "Science of Reading Configuration",
      disabledRostering: true,
    };

    return (
      <div className="reports-root-container">
        <div className="reports-page-wrap">
          <TeacherSelections
            layout={TEACHER_LAYOUT.content}
            teacherSelectionTypes={selectionProps}
            history={this.props.history}
            isAdminReport={true}
          />
          <div className='ScienceOfReadingConfigPage'>
            <div className="science-of-reading-config-page-wrapper">
              <p className='science-of-reading-config-info'>Changes you make here will affect all students in your district.</p>
              <section className='student-experience-config'>
                <div className='config-page-section-title'>CONFIGURE THE STUDENT EXPERIENCE</div>
                <ConfigCard title='IMAGES IN STORIES'>
                  <div className='images-in-stories-row'>
                    <img className='amira-skill-icon' src={GetBrandedSkillScaffoldIcon()} alt='' />
                    <div className='images-switch'>
                      <Toggle
                        className='teacherStyle'
                        onToggle={() => {
                          this.setState((prevState) => ({
                            imagesInStories: {
                              ...prevState.imagesInStories,
                              earlyReader: !prevState.imagesInStories.earlyReader
                            },
                          }))
                        }}
                        leftOptionName="OFF"
                        rightOptionName="ON"
                        left={!this.state.imagesInStories.earlyReader}
                      />
                    </div>
                    <div className='images-in-stories-info'>Images will be shown in the Early Reader Skill Scaffold</div>
                  </div>
                  <div className='images-in-stories-row'>
                    <img className='amira-skill-icon' src={GetBrandedStandardPracticeIcon()} alt='' />
                    <div className='images-switch'>
                      <Toggle
                        className='teacherStyle'
                        onToggle={() => {
                          this.setState((prevState) => ({
                            imagesInStories: {
                              ...prevState.imagesInStories,
                              standardAmiraPractice: !prevState.imagesInStories.standardAmiraPractice
                            },
                          }))
                        }}
                        leftOptionName="OFF"
                        rightOptionName="ON"
                        left={!this.state.imagesInStories.standardAmiraPractice}
                      />
                    </div>
                    <div className='images-in-stories-info'>Images will be shown in Standard {GetBrandedAppName()} Practice</div>
                  </div>
                </ConfigCard>
                <ConfigCard title='INTERVENTION FREQUENCY' description={`Choose how often you'd like ${GetBrandedTutorName()} to intervene during Standard ${GetBrandedAppName()} Practice`}>
                  <div className='intervention-frequency-row'>
                    <Dropdown
                      options={interventionFrequencyOpts}
                      value={this.state.interventionFrequencySelection}
                      onChange={(value) => this.setState({ interventionFrequencySelection: value })}
                      isDisabled={false}
                    />
                  </div>
                </ConfigCard>
                <ConfigCard title='GIVEWORD INTERVENTION'>
                  <div className='giveword-intervention-row'>
                    <Toggle
                      className='teacherStyle'
                      onToggle={() => {
                        this.setState((prevState) => ({
                          enableGiveWord: !prevState.enableGiveWord,
                        }));
                      }}
                      leftOptionName="OFF"
                      rightOptionName="ON"
                      left={!this.state.enableGiveWord}
                    />
                    <div className='giveword-info'>Enables the giveword intervention as a tutoring technique during practice, which gives the reader the word.</div>
                  </div>
                </ConfigCard>
              </section>
              <section className='student-configure-reporting'>
                <div className='config-page-section-title'>CONFIGURE REPORTING</div>
                <ConfigCard title='CHOOSE STANDARD USED IN REPORTING'>
                  <div className='configure-reporting-row'>
                    <div className='configure-reporting-dropdown'>
                      <Dropdown
                        options={standardReporting}
                        value={this.state.standardUsedInReporting}
                        onChange={(value) => this.setState({ standardUsedInReporting: value })}
                        isDisabled={false}
                      />
                    </div>
                    <div className='configure-reporting-info'>{this.state.standardUsedInReporting ? this.state.standardUsedInReporting.additionalInfo : ''}</div>
                  </div>
                </ConfigCard>
                <SelectCustomARMLevelMapping
                  selectedCustomARMLevelMapping={this.state.customARMLevelMapping}
                  setSelectedCustomARMLevelMapping={(customARMLevelMapping) => this.setState({ customARMLevelMapping })}
                />
                <SelectCurriculum
                  selectedCurriculum={this.state.curriculum}
                  setSelectedCurriculum={(curriculumArray) => this.setState({ curriculum: curriculumArray })}
                />
                <ConfigCard title='CHOOSE SCALES USED IN REPORTING' description={`The following scales will be available in ${GetBrandedAppName()} reports:`}>
                  <div className='configure-scales-reporting-row'>
                    <div>
                      <input
                        type='checkbox'
                        name='DRA'
                        onChange={() => this.setState((prevState) => ({
                          enableDRA: !prevState.enableDRA,
                        }))}
                        checked={this.state.enableDRA}
                      />
                      <label htmlFor='DRA'>DRA</label>
                    </div>
                    <div>
                      <input
                        type='checkbox'
                        name='Lexile'
                        onChange={() => this.setState((prevState) => ({
                          enableLexile: !prevState.enableLexile,
                        }))}
                        checked={this.state.enableLexile}
                      />
                      <label htmlFor='Lexile'>Lexile measure (based on grade equivalency)</label>
                    </div>
                  </div>
                </ConfigCard>
                <ConfigCard title='F&P READING LEVEL ON REPORTS'>
                  <div className='giveword-intervention-row'>
                    <Toggle
                      className='teacherStyle'
                      onToggle={() => {
                        this.setState((prevState) => ({
                          enableFandP: !prevState.enableFandP,
                        }));
                      }}
                      leftOptionName="OFF"
                      rightOptionName="ON"
                      left={!this.state.enableFandP}
                    />
                    <div className='giveword-info'>{GetBrandedAppName()} will show the F&amp;P reading level on the Benchmark Report</div>
                  </div>
                </ConfigCard>
                <ConfigCard title='SHOW EXTENDED COLUMNS IN TRANSCRIPTS'>
                  <div className='giveword-intervention-row'>
                    <Toggle
                      className='teacherStyle'
                      onToggle={() => {
                        this.setState((prevState) => ({
                          enableExtendedColumns: !prevState.enableExtendedColumns,
                        }));
                      }}
                      leftOptionName="OFF"
                      rightOptionName="ON"
                      left={!this.state.enableExtendedColumns}
                    />
                    <div className='giveword-info'>Amira will show the self-corrections, skips, and mistakes columns on the Review Activity screen</div>
                  </div>
                </ConfigCard>
              </section>
              <section className='control-btn-wrapper'>
                <div onClick={this.handleSave} className='save-config-btn'>Save</div>
              </section>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ScienceOfReadingConfig;